<cs-header>
  <cs-header-title>{{ LL.settings.notifications.sectionTitle() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-card-content>
        <div class="settings-section">
          <div class="setting-description section-description">{{ LL.settings.notifications.description() }}</div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">{{ LL.settings.notifications.workout() }}</div>
              <div class="setting-description">{{ LL.settings.notifications.workoutDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="settings.notificationsWorkout" (checkedChange)="onNotificationToggleChange('workout', settings.notificationsWorkout)"></cs-toggle>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">{{ LL.settings.notifications.meals() }}</div>
              <div class="setting-description">{{ LL.settings.notifications.mealsDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="settings.notificationsMeals" (checkedChange)="onNotificationToggleChange('meals', settings.notificationsMeals)"></cs-toggle>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">{{ LL.settings.notifications.weighIn() }}</div>
              <div class="setting-description">{{ LL.settings.notifications.weighInDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="settings.notificationsWeighIn" (checkedChange)="onNotificationToggleChange('weighIn', settings.notificationsWeighIn)"></cs-toggle>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">{{ LL.settings.notifications.weeklyCheckup() }}</div>
              <div class="setting-description">{{ LL.settings.notifications.weeklyCheckupDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="settings.notificationsWeeklyCheckup" (checkedChange)="onNotificationToggleChange('weeklyCheckup', settings.notificationsWeeklyCheckup)"></cs-toggle>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">{{ LL.settings.notifications.sleep() }}</div>
              <div class="setting-description">{{ LL.settings.notifications.sleepDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="settings.notificationsSleep" (checkedChange)="onNotificationToggleChange('sleep', settings.notificationsSleep)"></cs-toggle>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-description">{{ LL.settings.notifications.deviceSettingsDescription() }}</div>
            </div>
            <div class="setting-control">
              <cs-button small secondary (click)="openDeviceNotificationSettings()" [label]="LL.settings.notifications.deviceSettings()"></cs-button>
            </div>
          </div>
        </div>
      </cs-card-content>
    </cs-card>
  </cs-card-list>
</cs-content>
